import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-fs-header',
  templateUrl: './fs-header.component.html',
  styleUrls: ['./fs-header.component.scss'],
})
export class FsHeaderComponent implements OnInit {
  isCollapsed: boolean = false;

  constructor() {}

  ngOnInit(): void {}

  collapseHeader() {
    this.isCollapsed = !this.isCollapsed;
  }
}